import React from 'react';
import { Link } from 'react-router-dom';
import { FiMessageCircle, FiSend } from 'react-icons/fi';
import { HomeReveal } from './HomeMotion';

const HomeFinalCta = () => (
  <HomeReveal as="section" className="home-cta">
    <div className="home-container home-cta-inner">
      <h2>Ready to elevate your team’s productivity?</h2>
      <p>
        Register for free today and access all features without providing any credit card details. You pay for premium services and only for what you use.
      </p>
      <div className="home-cta-alt">
        <Link to="/register" className="home-cta-outline">
          <FiSend /> Get Started
        </Link>
        <Link to="/contact-us" className="home-cta-outline">
          <FiMessageCircle /> Contact Sales
        </Link>
      </div>
    </div>
  </HomeReveal>
);

export default HomeFinalCta;
